/*
 * Purpose : Page Not Found Page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */
import React from 'react';
import '../../css/form.css';
import Logo from './../../assets/UnderConstruction.png';
import Grid from '@material-ui/core/Grid';

const notFound = () => {
    return(
        <div className={"form"}>
            {/* <HomeNavigation /> */}
            <Grid item xs={12}>
                <div style={{textAlign:"center"}}>
                    <h2>404. The page you requested is not found</h2>
                    {/* TODO need to comment img part */}
                    <img src={Logo} alt="page Under Construction" className={"img"}></img>
                </div>
            </Grid>
        </div>
    )
}
export default notFound;